import { render } from "./ModelView.vue?vue&type=template&id=358fc719"
import script from "./ModelView.vue?vue&type=script&lang=js"
export * from "./ModelView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__